<!-- //ANCHOR - ism-marquee -->
<div class="mx-auto w-1/3 flex items-center justify-center rounded-2xl ism-green">
  <ism-svg [name]="'saturnPurple'" [classString]="'w-20 h-20 flex items-center text-gray-300'"></ism-svg>
  <div class="ml-2 font-extrabold flex items-center justify-center tracking-normal ism-blue text-2">iSkyMarshal</div>
</div>
